module.exports = __webpack_public_path__ + "img/cross_btn.487bd82d.svg";